import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { SaleKindModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { SaleKindBO } from './sale-kind.bo';


@Repository({
    boType: SaleKindBO,
    apiController: {
        base: 'sales/kinds/:name',
        tags: [Tags.Api]
    }
})
export class SaleKindRepositoryBase extends RepositoryBase<SaleKindBO, SaleKindModel> {
    public constructor(
        private readonly weaver: Weaver,
        $http: HttpService,
    ) {
        super($http);
    }

    protected createBO(): SaleKindBO {
        return new SaleKindBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: SaleKindModel): Promise<any> {
        return {
            version: model.version,
            name: model.name,

            adjustment: model.adjustment,
            adjustmentDefaultDueDate: model.adjustmentDefaultDueDate,
            adjustmentDefaultPaymentMethodId: model.adjustmentDefaultPaymentMethodId,
            automaticallyAddPayment: model.automaticallyAddPayment,
            customTransactionLocation: model.customTransactionLocation,
            defaultCalculationMethod: model.defaultCalculationMethod,
            defaultNumberingId: model.defaultNumberingId,
            defaultAdjustmentNumberingId: model.defaultAdjustmentNumberingId,
            defaultDueDate: model.defaultDueDate,
            defaultMarginSchemeId: model.defaultMarginSchemeId,
            defaultPaymentMethodId: model.defaultPaymentMethodId,
            useCustomTransactionLocation: model.useCustomTransactionLocation
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<SaleKindModel> {
        return new SaleKindModel(pickBy<SaleKindModel>({
            version: item.version,
            name: item.name,

            adjustment: item.adjustment,
            adjustmentDefaultDueDate: item.adjustmentDefaultDueDate,
            adjustmentDefaultPaymentMethodId: item.adjustmentDefaultPaymentMethodId,
            automaticallyAddPayment: item.automaticallyAddPayment,
            customTransactionLocation: item.customTransactionLocation,
            defaultCalculationMethod: item.defaultCalculationMethod,
            defaultNumberingId: item.defaultNumberingId,
            defaultAdjustmentNumberingId: item.defaultAdjustmentNumberingId,
            defaultDueDate: item.defaultDueDate,
            defaultMarginSchemeId: item.defaultMarginSchemeId,
            defaultPaymentMethodId: item.defaultPaymentMethodId,
            useCustomTransactionLocation: item.useCustomTransactionLocation
        }, val => val !== void 0));
    }

    //#endregion
}
